import * as layerOps from '../api/Layers/layer-operations';

import getGeoJSONFromTable from './get-geojson-from-table';
import loadExcelFromURL from './load-excel-from-url';

/**
 * Fetches the Spatial Excel and returns the geojson.
 *
 * @async
 * @param {object} layer - The excel layer.
 * @returns {object} The geojson.
 * @throws {Error} If something goes wrong.
 */
const getGeoJSONFromExcel = async layer => {
  try {
    const { tableTitle, tableBody } = await loadExcelFromURL(layer);
    return getGeoJSONFromTable({
      georefType: layerOps.getGeorefType(layer),
      h3Index: layerOps.getH3Index(layer),
      spatialTableFields: layerOps.getTableSpatialObject(layer),
      tableBody,
      tableTitle
    });
  } catch (err) {
    throw new Error(err.message);
  }
};

export default getGeoJSONFromExcel;
